import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import * as CanvasJS from '../../canvasjs.min';
import * as Chart from '../../chart';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import  jspdf from 'jspdf';
import html2canvas from 'html2canvas';
declare let swal:any;
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-generation-of-graphs',
  templateUrl: './generation-of-graphs.component.html',
  styleUrls: ['./generation-of-graphs.component.css']
})
export class GenerationOfGraphsComponent implements OnInit {
  loginresponse:any;
  userrole:any;
  farm_userrole:any;
  form_id:any;
  getlistApi:any;
  getlistApi2:any;
  selectallvalue:any;
  getfarmsListData:any;
  loadspeciesValue:any;
  getspeciesvalue:any;
  addUrl:any;
  isLoading:true;
  speciesloaddata:any;
  getData:any=[]; 
  getExportData:any=[]; 
  from_date:any;
  to_date:any;
  getExportData1:any;
  getData1:any;
  chartData:any;
  chartData1:any;
  get_age:any;
  ageUrl :any;
  point_style:any=['{"type":"star","sides":"5"}','{"type":"star","sides":"4"}','{"type":"star","sides":"3"}','{"type":"star","sides":"2"}','{"type":"star","sides":"7"}','{"type":"star","sides":"9"}','{"type":"triangle"}','{"type":"square"}','{"type":"diamond"}','{"type":"polygon"}','{"type":"circle"}'];
  constructor(private router: Router,private commonService: CommonService,private formBuilder: FormBuilder) { }

  async ngOnInit(): Promise<void> {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
      this.form_id=this.farm_userrole;
    }else{
    this.form_id=null;
    }
  
    this.isLoading =true;
    var table;
    $('.selectpicker').selectpicker('refresh');
    //$('#reportrange_date').daterangepicker('refresh');
    //$('#reportrange_date').daterangepicker('setDate', 0);
    this.getlistApi=(this.form_id!=null)?'/farms/'+this.form_id:"/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async(res) => {
         $(function(){
         table = $("#myTable").DataTable();
         })
         this.getfarmsListData = (this.form_id!=null)?[res.data]:res.data;
         this.getfarmsListData.unshift({tnfr_id:null,tnfr_name:"Select Farm Name"});
  });
      

  setTimeout(function () {
   $('#reportrange_date').daterangepicker('refresh');
    $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
    //$('#reportrange_date').daterangepicker('refresh');
 }, 1500);



 
     if(this.form_id!=null){
      this.getlistApi= "/species/?farm_user="+this.form_id;
     }
     else{
      this.getlistApi= "/species";
     }
     (await this.commonService.getApi(this.getlistApi)).subscribe(
       (res) => {
    
          $(function(){
          table = $("#myTable").DataTable();
          })
           this.speciesloaddata = res.data;
           this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
           setTimeout((res)=>{ 
      }, 500);
         
          }) 


 $('#farmname').change(async ()=> {
  $("#speciesid").find('option').remove().end();
  console.log(  $('#farmname').val())
    this.selectallvalue= $('#farmname').val();
    var farmvalue="";
farmvalue = this.selectallvalue.toString();
this.loadspeciesValue = {
"farms_id":farmvalue
};
console.log(this.loadspeciesValue.farm_id)
if(farmvalue!="null"){
      //species load in select dropdown based on farm select api call
      this.addUrl = "/species/farms";
      (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
        res => {
          this.speciesloaddata=res.data;
          this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
          console.log( this.speciesloaddata)
          
        })
      }else{
        $('#Speciesname').val('null');
        this.speciesloaddata=[{id:null,name:"Select Species Name"}];
        $('#BreedName').val('null');
        this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
       $('#age').val('null');
       this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
      }
        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
       }, 1500);
  });

   this.chartData = {
    type: 'ScatterChart',
    data:  [
        [
            "Month",
            0
        ]
    ],
    columnNames: ["Month",'' ],
    options: {
        legend: { position: 'bottom', maxLines: 3 },
        bar: { groupWidth: '75%' },
        colors: ['#ffffff','#ffffff']
    },
    width: 800,
    height: 300
    };

    this.chartData1 = {
      type: 'ScatterChart',
      data:  [
        [
            "Season",
            0
        ]
    ],
      columnNames: ["Month",""],
      options: {
          legend: { position: 'bottom', maxLines: 3 },
          bar: { groupWidth: '75%' },
          colors: ['#ffffff','#ffffff']
      },
      width: 800,
      height: 300
      };
      $(document).on('change', '#farmname', function() {
        $('.myFakeClass').dropdown('toggle');
      });
      $(document).on('change', '#Speciesname', function() {
        $('.myFakeClass1').dropdown('toggle');
      });
      $(document).on('change', '#BreedName', function() {
        $('.myFakeClass2').dropdown('toggle');
      });
      $(document).on('change', '#age', function() {
        $('.myFakeClass3').dropdown('toggle');
      });
  }
  async breedselectbyspecies(event){
    console.log(event.target.value);
    if(event.target.value!='null'){
    this.addUrl = "/breeds/species/"+event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getspeciesvalue=res.data;
           this.getspeciesvalue.unshift({id:null,name:"Select Breed Name"});
          console.log(this.getspeciesvalue);
      });
      this.ageUrl="/species/age_group/all_category/?species_id="+event.target.value;
      (await this.commonService.getApi(this.ageUrl)).subscribe(
        res => {
             this.get_age=res.data;
             this.get_age.unshift({tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'});
            console.log(this.get_age);
        });
     
    }else{
      $('#BreedName').val('null');
      this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
     $('#age').val('null');
     this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
    }   
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
  }
 
  
  date_format(dateObject) {
    var d = new Date(dateObject);
    let day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var day1 ;
    var month1 ;
    if (day < 10) {
        day1 = "0" + day;
    }else{
       day1 = day;
    }
    if (month < 10) {
        month1 = "0" + month;
    }else{
       month1 =  month;
    }
    var date = year + "-" + month1;
  
    return date;
  };

  async get_datas(){
    
    var from_date_pic = $("input[name='daterangepicker_start']" ).val();
    var to_date_pic = $("input[name='daterangepicker_end']" ).val();
    this.from_date = this.date_format(from_date_pic);
    this.to_date = this.date_format(to_date_pic);
    //var farm_id=$('#farmname').val();
    var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
    var species_id=$('#Speciesname').val();
    var breed_id=$('#BreedName').val();
    var age=$('#age').val();
    //console.log($('div.date_range span').text());

    if(species_id==null || species_id==''){
      alert("Please choose any species");return false;
    } 

    this.getlistApi="/reports/monthly_percentage_allfarms/?from_date="+this.date_format(from_date_pic)+"&to_date="+this.date_format(to_date_pic)+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
    //+"&breed_id="+breed_id
     (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {          
        console.log(res.data);
        this.getExportData=res;
        this.getData = res;
var i=0;
var objects = {};
//var randomNumber = Math.floor(Math.random()*this.point_style.length);
        for(i=0;i<this.getData.color.length;i++){
          var text_name=this.point_style[Math.floor(Math.random() * this.point_style.length)];
            objects[i]= {pointShape : JSON.parse(text_name)};
        }
       console.log(objects);
        this.chartData = {
          type: 'ScatterChart',
          data: this.getData.data,
         columnNames: this.getData.columnNames,
         options: {
            //legend: { position: 'bottom', maxLines: 3 },
            bar: { groupWidth: '75%' },
            colors: this.getData.color,
            pointSize: 15,
            series: objects,
            vAxis:{
			           title: 'Monthly EADR'
			       },
         },
         width: 1000,
         height: 300
        }; 
         
         }) ;
         this.getlistApi2="/reports/season_percentage_allfarms/?from_date="+this.date_format(from_date_pic)+"&to_date="+this.date_format(to_date_pic)+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
         (await this.commonService.getApi(this.getlistApi2)).subscribe(
          (res) => {          
            console.log(res.data);
            this.getExportData1=res;
            this.getData1 = res;
                 
            var i=0;
var objects = {};
//var randomNumber = Math.floor(Math.random()*this.point_style.length);
        for(i=0;i<this.getData1.color.length;i++){
          var text_name=this.point_style[Math.floor(Math.random() * this.point_style.length)];
            objects[i]= {pointShape : JSON.parse(text_name)};
        }
       console.log(objects);

            this.chartData1 = {
              type: 'ScatterChart',
              data: this.getData1.data,
             columnNames: this.getData1.columnNames,
             options: {
               // legend: { position: 'bottom', maxLines: 3 },
                bar: { groupWidth: '75%' },
                colors: this.getData1.color,
                pointSize: 15,
                series: objects,
                vAxis:{
                     title: 'EADR'
                 },
             },
             width: 1000,
             height: 300
            }; 
            
             }) ;
  }

  
  public exportdata()
{
//var data = document.getElementById('contentToConvert');
let data = document.getElementById('contentToConvert');  
html2canvas(data).then(canvas => {
  const contentDataURL = canvas.toDataURL('image/png')  
  let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
  // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
  pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);  
  pdf.save('Generation_of_other_graphs.pdf');   
}); 
}



}
